import React from "react";
import { Link } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";

import { Params } from "./../params.jsx";
import pc1 from "./../assets/images/pc1.PNG";
import pc2 from "./../assets/images/pc2.PNG";
import pc3 from "./../assets/images/pc3.PNG";
import pc4 from "./../assets/images/pc4.PNG";
import pc5 from "./../assets/images/pc5.PNG";
import menu from "./../assets/images/menu.png";
import { Flags } from "./../assets/images/flags.jsx";
import "./../css/monte.css";
import "./../css/reset.css";

export default function MainLayer({ lang, onLang, children }) {
  return (
    <div className="mx-2">
	        <div className="picture mt-3">
	          <img src={pc1} alt = "pc1"/>
	          <img src={pc2} alt = "pc2"/>
	          <img src={pc3} alt = "pc3"/>
	          <img src={pc4} alt = "pc4"/>
	          <img src={pc5} alt = "pc5"/>
	        </div>


	        <div className="first-head pt-3 pb-3">
	          <div className="fs-2 ms-md-5 w-100">
	            <div className="container-fluid ">
	              <div className="row">
	                <div className="col-md-6 head-span">   
	                  <span className="myfs-1 text-white fst-italic">Montenegro?</span>
	                </div>
	                <div className="col-md-6 mt-3">    
	                  <span className="myfs-2 text-white fst-italic ">{Params(lang).here}</span>
	                </div>
	              </div>  
	            </div>
	          </div>

	        	<div className="d-flex mt-3 me-md-5 me-3">
	            				<NavDropdown title={<img src={Flags(lang)} alt="flag"/>} id="basic-nav-dropdown">
							          <NavDropdown.Item onClick={onLang('ru')}>ru</NavDropdown.Item>
							          <NavDropdown.Item onClick={onLang('en')}>en</NavDropdown.Item>
							          <NavDropdown.Item onClick={onLang('de')}>de</NavDropdown.Item>
						          	<NavDropdown.Item onClick={onLang('sr')}>sr</NavDropdown.Item>
						        	</NavDropdown>


						        <NavDropdown title={<img src={menu} alt = "menu"/>} id="basic-nav-dropdown">
						          <NavDropdown.Item as={Link} to="/rooms">{Params(lang).rooms}</NavDropdown.Item>
						          <NavDropdown.Item as={Link} to="/makondo">{Params(lang).about}</NavDropdown.Item>
						          <NavDropdown.Item as={Link} to="/more">{Params(lang).more}</NavDropdown.Item>
						          <NavDropdown.Item as={Link} to="/confid">{Params(lang).confid}</NavDropdown.Item>
						        </NavDropdown>

	            </div>
						      
	          </div>
        
        {children}

		<div className="bg6 d-flex justify-content-center pt-4 pb-4 flex-wrap ">
          <div><a href="https://icons8.ru/icons/set/флаги" className="text-primary">flags from Icons8 </a>&nbsp; &nbsp;</div>
          <div>Copyright &copy; 2021 &nbsp; allof.best &nbsp; &nbsp;</div>
          <div>Made with Yii</div>
      	</div>
	</div>

  );
}